import {every, includes, some} from 'lodash'

export function deferred () {
  let _resolve
  let _reject
  const promise = new Promise((resolve, reject) => {
    _resolve = resolve
    _reject = reject
  })
  return {
    promise,
    resolve: _resolve,
    reject: _reject,
    then (r) {
      return promise.then(r)
    },
    catch (e) {
      return promise.catch(e)
    }
  }
}

/**
 * Converts javascript Object to string without double quotes for property names.
 * See: https://stackoverflow.com/a/55579862/4610753
 *
 * @param jsonObject
 * @param tab
 * @returns {string}
 */
export const objectStringify = (jsonObject, tab = 0) => {
  return _objectStringify(jsonObject, tab)
}
const _objectStringify = (jsonObject, tab = 0, _lvl = 0) => {
  if (jsonObject == null) {
    return 'null'
  }
  const t = ' '.repeat(tab)
  const lvlStr = t.repeat(_lvl)
  // const nextLvl = lvl + '  '
  const nextLvl = _lvl + 1
  const nextLvlStr = t.repeat(nextLvl)
  // In case of an array we'll stringify all objects.
  if (Array.isArray(jsonObject)) {
    let res = jsonObject
      .map(obj => `${_objectStringify(obj, tab, nextLvl)}`)
      .join(', ')
    return `[${res}]`
  }
  // not an object, stringify using native function
  if (typeof jsonObject !== 'object' || jsonObject instanceof Date) {
    return JSON.stringify(jsonObject)
  }
  // Implements recursive object serialization according to JSON spec
  // but without quotes around the keys.

  let res = Object.keys(jsonObject)
    .map(key => `${key}: ${_objectStringify(jsonObject[key], tab, nextLvl)}`)
    // .join(',\n' + nextLvl)
    .join(',\n' + nextLvlStr)
  return `{\n${nextLvlStr}${res}\n${lvlStr}}`
}

export function shortenizeFullName (fullName) {
  if (!fullName) return null
  const substrings = fullName && fullName.split(' ').filter(s => !!s)
  substrings.slice(0, 3)
  const lastName = substrings.shift()
  let initials = [...substrings.map(name => name.substr(0, 1).toUpperCase()), ''].join('.')
  if (substrings.length === 1) {
    const matches = substrings[0].match(/\./g)
    if (matches && matches.length === 2) {
      // is already shortened (has two dots)
      initials = substrings[0]
    }
  }
  return [lastName, initials].join(' ').trim()
}

export function arrayMove (array, fromIndex, toIndex) {
  array.splice(toIndex, 0, array.splice(fromIndex, 1)[0])
}

/**
 * Bankers rounding
 *
 * @see https://stackoverflow.com/questions/3108986/gaussian-bankers-rounding-in-javascript
 */
export function evenRound (num, decimalPlaces) {
  const d = decimalPlaces || 0
  const m = Math.pow(10, d)
  const n = +(d ? num * m : num).toFixed(8) // Avoid rounding errors
  const i = Math.floor(n)
  const f = n - i
  const e = 1e-8 // Allow for rounding errors in f
  const r = (f > 0.5 - e && f < 0.5 + e) ? ((i % 2 === 0) ? i : i + 1) : Math.round(n)
  return d ? r / m : r
}

/*
 * createUUID
 *
 * Returns RFC4122, version 4 ID
 */
const createUUID = (function (uuidRegEx, uuidReplacer) {
  return function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(uuidRegEx, uuidReplacer).toUpperCase()
  }
})(/[xy]/g, function (c) {
  var r = Math.random() * 16 | 0,
    v = c === 'x' ? r : (r & 3 | 8)
  return v.toString(16)
})

export { createUUID }

/**
 * Filtered By FreeSearch.
 *
 * @param freeSearch
 * @param filteredItems
 * @param [isFullMatchMode]
 * @returns {Array}
 */
export function filteredByFreeSearch (freeSearch, filteredItems, isFullMatchMode) {
  // default match mode
  if (isFullMatchMode === undefined) {
    isFullMatchMode = true
  }
  let substrings = (freeSearch && freeSearch.toLowerCase().split(' ').filter(s => s.length > 0)) || []
  filteredItems = filteredItems.filter(filteredItem => {
    return isFullMatchMode
      ? every(substrings, (el) => includes(filteredItem.searchString, el))
      : some(substrings, (el) => includes(filteredItem.searchString, el))
  })
  return filteredItems
}

/**
 * Sleep - can be used in async/await variant
 */
export function sleep (ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export function isAsciiOnly (string) {
  return /^[\x00-\x7F]+$/.test(string) // eslint-disable-line
}



// WEBPACK FOOTER //
// ./src/utils/misc.js